var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['kiosk', ("" + (_vm.$route.name))]},[(_vm.$route.path.indexOf('bank-use') !== -1)?_c('BankUseHeader'):(
      _vm.$route.path.indexOf('bank-alone') !== -1 ||
        _vm.$route.path.indexOf('payment') !== -1
    )?_c('BankAloneHeader',{attrs:{"max_count":_vm.login_count}}):_c('KioskHeader',{attrs:{"max_count":_vm.login_count}}),_c('router-view',{on:{"payment_count":_vm.countModify}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }